import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Role } from '@interfaces/enums';
import { UserService } from './user.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const router: Router = inject(Router);
  const userService: UserService = inject(UserService);

  const userRole: Role = await userService.getProfilInfos();
  console.log(userRole);
  const expectedRoles: Role[] = route.data['roles'];
  const hasRole: boolean = expectedRoles.some((role) => userRole === role);

  return hasRole || router.navigate(['login']); // TODO
};
